import { getFuturePayments } from './scheduledPayments/getFuturePayments'
import { isDateInPast } from 'Rentlio/helper/isDateInPast'
import { FIRST_NIGHT } from 'Rentlio/utils/CancellationPolicyFeeTypeEnum'

export const getBillingDynamicsInfo = (
  currencyConversion,
  totalRatePrice,
  reservationCurrency,
  policy,
  arrival,
  createdAt,
  firstNightPrice
) => {
  const {
    fullAmountWillBePaid,
    amountWillBePaidDaysBefore,
    prepaymentAmountDueDate,
    prepaymentAmountType,
    prepaymentAmount
  } = policy
  const { value: total, currency } = currencyConversion(totalRatePrice, reservationCurrency)

  const isAmountWillBePaidDaysBeforeInThePast = isDateInPast(
    arrival.clone().subtract(amountWillBePaidDaysBefore ? +amountWillBePaidDaysBefore : 0, 'days'),
    false,
    createdAt
  )
  const prepaymenyAmountPercentage = prepaymentAmountType === FIRST_NIGHT ? null : Number(prepaymentAmount)
  const isPrepaymentInThePast = isDateInPast(
    arrival.clone().subtract(prepaymentAmountDueDate ? +prepaymentAmountDueDate : 0, 'days'),
    false,
    createdAt
  )

  const scheduledPayments = getFuturePayments(
    arrival,
    total,
    currency,
    amountWillBePaidDaysBefore,
    prepaymentAmountType,
    prepaymenyAmountPercentage,
    prepaymentAmountDueDate,
    firstNightPrice,
    createdAt
  )

  return {
    prepaymenyAmountPercentage,
    isPrepaymentInThePast,
    total,
    currency,
    prepayment: scheduledPayments?.length > 0 ? scheduledPayments[0]?.amount : 0,
    remainingAmount: scheduledPayments?.length > 1 ? scheduledPayments[1]?.amount : 0,
    fullAmountWillBePaid,
    amountWillBePaidDaysBefore,
    prepaymentAmountDueDate,
    isAmountWillBePaidDaysBeforeInThePast
  }
}
